import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { ListLinks } from '../../../../@core/constants/list-links';
import { BackupTarget, BackupTargetSearchInput, SearchInput } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { BackupTargetService } from '../../services/backup-target.service';
import { BackupTargetEditWidgetComponent } from '../backup-target-edit-widget/backup-target-edit-widget.component';

@Component({
    selector: 'app-backup-target-drop-down',
    templateUrl: './backup-target-drop-down.component.html',
    providers: [BackupTargetService],
    standalone: true,
    imports: [CommonModule],
})
export class BackupTargetDropDownComponent extends GenericBaseModelDropDown<BackupTarget> implements AfterViewInit {
    constructor(private backupTargetService: BackupTargetService) {
        super(backupTargetService, 'BackupTarget');
        this.createNewPopupComponent = BackupTargetEditWidgetComponent;
        this.listUrl.set(ListLinks.BACKUP_TARGETS);
    }

    override ngAfterViewInit() {
        this.buildFilter();
        super.ngAfterViewInit();
    }

    buildFilter() {
        // Apply inactive filter - always filter by active targets (inactive: false)
        (this.si as BackupTargetSearchInput).inactive = false;
    }

    override executeSearch(searchInput: SearchInput) {
        this.buildFilter();
        return super.executeSearch(searchInput);
    }
}
